import { render, staticRenderFns } from "./create-ads.vue?vue&type=template&id=36f9dd88&"
import script from "./create-ads.vue?vue&type=script&lang=js&"
export * from "./create-ads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports